(function ($) {
    'use strict';
    $(document).ready(function () {

        var resizePoster = function () {
            $('.link-poster-media-article').each(function () {
                $(this).height($(this).width() / 1.6);
            });
        };

        resizePoster();

        $(window).resize(function () {
            resizePoster();
        });
    });
})(jQuery);
